import jwt_decode from "jwt-decode";

import { ACCESS_TOKEN_LOCAL_STORAGE_KEY } from "core/common/constants/localstorage";
import * as Constants from "core/common/constants/common";

const useJwtTokenData = () => {

    const tokenData = (() => {
        let data;
        return {
            get: () => {
                if (!data) {
                    const token = sessionStorage.getItem(ACCESS_TOKEN_LOCAL_STORAGE_KEY);
                    if (token) {
                        data = jwt_decode(token);
                    }
                }
                return data;
            }
        };
    })();

    const hasAdminRole = () => {
        const data = tokenData.get();
        //console.log({ data })
        return data?.Role === Constants.roles.admin;
    }

    const hasNoAdminRole = () => {
        const data = tokenData.get();
        return data?.Role !== Constants.roles.admin;
    }

    return {
        hasAdminRole,
        tokenData,
        hasNoAdminRole
    };
}

export default useJwtTokenData;